import { IExtendedApiError } from "./i-extended-api-error.js"

export class ExtendedApiError extends Error implements IExtendedApiError {
    errorCode: number;
    errorMessage: string;
    devErrorMessage: string;
    devStackTrace: string;

    constructor(response: IExtendedApiError) {
        super(`
Response error: ${response.errorMessage}
Error code: ${response.errorCode}
Message: ${response.devErrorMessage}
Stack: ${response.devStackTrace}`);

        this.errorCode = response.errorCode;
        this.errorMessage = response.errorMessage;
        this.devErrorMessage = response.devErrorMessage;
        this.devStackTrace = response.devStackTrace;
    }
}